import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

const alertProviderOptions = {
  position: positions.TOP_CENTER,
  timeout: 10000,
  offset: '30px',
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 10000
  }
}

const Root = () => (
  <AlertProvider template={AlertTemplate} {...alertProviderOptions}>
    <App />
  </AlertProvider>
)

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
